// extracted by mini-css-extract-plugin
export default {"index":"Detail_index__wqKLo","con":"Detail_con__+N1G6","shopArea":"Detail_shopArea__sPPkK","title":"Detail_title__NTA31"};